<template>
  <div class="startup-manage">
    <!-- 搜索工具栏 -->
    <div class="toolbar">
      <label style="padding: 0 5px 0 15px;">配置主题:</label>
      <el-input
        v-model="searchForm.name"
        placeholder="请输入配置主题"
        style="width: 150px; margin-right: 10px"
        clearable
      />
      
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleShowAll">全部</el-button>
      
      <el-button type="success" icon="el-icon-plus" style="float: right" @click="handleAdd">
        添加
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      height="calc(100vh - 200px)"
    >
      <el-table-column type="index" label="序号" width="60" align="center" />
      
      <el-table-column prop="name" label="配置主题" width="150" align="center" />
      
      <el-table-column prop="os_type" label="终端类型" width="80" align="center">
        <template slot-scope="scope">
          {{ formatOsType(scope.row.os_type) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="disabled" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
            {{ scope.row.disabled ? '禁用' : '启用' }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="created_at" label="创建时间" width="130" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="updated_at" label="更新时间" width="130" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="operator" label="操作人" width="130" align="center" />
      
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="info" @click="handleView(scope.row)">查看</el-button>
          <template v-if="scope.row.disabled">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            <el-button size="mini" type="success" @click="handleToggleStatus(scope.row)">启用</el-button>
          </template>
          <template v-else>
            <el-button size="mini" type="warning" @click="handleToggleStatus(scope.row)">禁用</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-sizes="[10, 15, 20, 50]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />

    <!-- 编辑对话框 -->
    <StartupEditDialog
      :visible.sync="editDialogVisible"
      :startup-data="currentStartup"
      :app-info="appInfo"
      @refresh="loadStartupList"
    />
  </div>
</template>

<script>
import { getStartupList, toggleStartupStatus, deleteStartup } from '@/api/custom-frontend'
import StartupEditDialog from './StartupEditDialog.vue'

export default {
  name: 'AppStartupManage',
  components: {
    StartupEditDialog
  },
  props: {
    appInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        name: ''  // 修正为name字段，与老项目保持一致
      },
      pagination: {
        page: 1,
        pageSize: 15,
        total: 0
      },
      editDialogVisible: false,
      currentStartup: null
    }
  },
  watch: {
    appInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadStartupList()
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadStartupList() {
      if (!this.appInfo.id) return
      
      this.loading = true
      try {
        const params = {
          app_id: this.appInfo.id,
          type: 2, // 启动页类型
          page: this.pagination.page,
          rows: this.pagination.pageSize,
          ...this.searchForm  // 展开搜索参数，与引导页保持一致
        }
        
        console.log('启动页请求参数:', params)
        
        const res = await getStartupList(params)
        console.log('启动页响应数据:', res)
        
        if (res && res.err_code === 0) {
          this.tableData = res.rows || []
          this.pagination.total = res.total || 0
          console.log('启动页数据加载成功，数据量:', this.tableData.length)
        } else {
          console.error('获取启动页数据失败:', res ? res.err_msg : '无响应')
          this.$message.error((res && res.err_msg) || '获取启动页数据失败')
        }
      } catch (error) {
        console.error('获取启动页列表失败:', error)
        this.$message.error('获取启动页列表失败')
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pagination.page = 1
      this.loadStartupList()
    },
    
    handleShowAll() {
      this.searchForm = { name: '' }
      this.pagination.page = 1
      this.loadStartupList()
    },
    
    handleAdd() {
      this.currentStartup = null
      this.editDialogVisible = true
    },
    
    handleView(row) {
      this.currentStartup = { ...row, action: 'view' }
      this.editDialogVisible = true
    },
    
    handleEdit(row) {
      this.currentStartup = { ...row }
      this.editDialogVisible = true
    },
    
    async handleToggleStatus(row) {
      const action = row.disabled ? '启用' : '禁用'
      try {
        await this.$confirm(`确认要${action}该启动页吗？`, '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await toggleStartupStatus({
          id: row.id,
          disabled: !row.disabled
        })
        
        if (res && res.err_code === 0) {
          this.$message.success(`${action}成功`)
          this.loadStartupList()
        } else {
          this.$message.error(res.err_msg || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error(`${action}启动页失败:`, error)
          this.$message.error(`${action}失败`)
        }
      }
    },
    
    async handleDelete(row) {
      try {
        await this.$confirm('确认要删除该启动页吗？', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await deleteStartup({ id: row.id })
        if (res && res.err_code === 0) {
          this.$message.success('删除成功')
          this.loadStartupList()
        } else {
          this.$message.error(res.err_msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除启动页失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.loadStartupList()
    },
    
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadStartupList()
    },
    
    formatOsType(value) {
      const typeMap = {
        1: 'Android',
        2: 'iOS'
      }
      return typeMap[value] || value
    },
    
    formatDate(value) {
      if (!value || +new Date(value) < 0) {
        return '-'
      }
      return this.$day(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.startup-manage {
  padding: 20px;
  height: 100%;
  
  .toolbar {
    padding: 8px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;
    
    .search-label {
      margin-right: 10px;
      font-weight: bold;
    }
    
    label {
      margin-right: 5px;
    }
    
    .el-button {
      margin-left: 5px;
    }
  }
}
</style>